import { z } from "zod";
export const GithubIntegrationStatus = z.object({
    configured: z.boolean(),
    orgLogin: z.string().nullable(),
    hasPat: z.boolean(),
    lastSyncedAt: z.string().datetime().nullable(),
    syncStatus: z.enum(["idle", "syncing", "error"]),
    syncError: z.string().nullable(),
});
export const GithubIntegrationUpsertRequest = z.object({
    orgLogin: z.string().min(1).max(100),
    /**
     * `undefined` (omitted) leaves the existing PAT untouched.
     * `null` clears the stored PAT.
     * A non-empty string installs a new PAT.
     */
    pat: z.string().nullable().optional(),
});
export const GithubSyncResponse = z.object({
    orgLogin: z.string(),
    teamsSynced: z.number().int().nonnegative(),
    teamsRemoved: z.number().int().nonnegative(),
    usersUpserted: z.number().int().nonnegative(),
    reposLinked: z.number().int().nonnegative(),
    reposCleared: z.number().int().nonnegative(),
});
export const GithubOrgRepo = z.object({
    fullName: z.string(),
    name: z.string(),
    description: z.string().nullable(),
    defaultBranch: z.string().nullable(),
    htmlUrl: z.string(),
    cloneUrl: z.string(),
    private: z.boolean(),
    archived: z.boolean(),
    fork: z.boolean(),
    pushedAt: z.string().datetime().nullable(),
    alreadyIngested: z.boolean(),
});
export const GithubOrgReposResponse = z.object({
    orgLogin: z.string(),
    repos: z.array(GithubOrgRepo),
});
export const GithubImportRequest = z.object({
    fullNames: z.array(z.string().min(1)).min(1).max(200),
});
export const GithubImportResult = z.object({
    fullName: z.string(),
    status: z.enum(["imported", "skipped", "failed"]),
    repoId: z.string().nullable(),
    message: z.string().nullable(),
});
export const GithubImportResponse = z.object({
    imported: z.number().int().nonnegative(),
    skipped: z.number().int().nonnegative(),
    failed: z.number().int().nonnegative(),
    results: z.array(GithubImportResult),
});
//# sourceMappingURL=github.js.map